import { Flex } from "antd";
import styled from "styled-components";

export const StyledContentBody = styled(Flex)`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    width: 100%;
`;

export const StyledModalTitle = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;

    .title-main {
        font-size: 18px;
        font-weight: 600;
        color: ${({ theme }) => theme.primaryTypographyColor};
        line-height: 1.3;
    }

    .title-subtitle {
        font-size: 14px;
        font-weight: 400;
        color: ${({ theme }) => theme.secondaryTypographyColor};
        line-height: 1.4;
    }
`;

export const StyledQRContainer = styled.div`
    padding: 16px;
    background: ${({ theme }) => theme.colors.white};
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ theme }) => theme.secondaryBorderColor};
    max-width: 100%;
    overflow: hidden;

    canvas {
        border-radius: 8px;
        max-width: 100%;
        height: auto !important;
        width: 100% !important;
    }
`;

export const StyledInfoBlock = styled.div`
    width: 100%;
    padding: 14px 16px;
    background: ${({ theme }) => theme.itemBackground};
    border: 1px solid ${({ theme }) => theme.secondaryBorderColor};
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .info-item {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;
    }

    .info-label {
        font-size: 13px;
        font-weight: 500;
        color: ${({ theme }) => theme.secondaryTypographyColor};
        white-space: nowrap;
        flex-shrink: 0;
    }

    .info-value {
        font-size: 13px;
        font-weight: 500;
        color: ${({ theme }) => theme.primaryTypographyColor};
        text-align: right;
        word-break: break-word;
    }
`;
